import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {getHomePage} from "api/Api";

const EmailIsConfirm = ()=>{
    const [userIsConfirm, setUserIsConfirm] = useState(true);
    useEffect(() => {
        getHomePage((isOk, data) => {
            if (isOk) {
                setUserIsConfirm(!!data.user_info.email)
            }
        });
    }, []);
    return(
        <>
            {!userIsConfirm ? (
                <div className={'px-4 py-3 mb-4 rounded-lg d-flex align-items-center flex-lg-row border-1 justify-content-between flex-column text-danger'} style={{
                    background: 'rgba(248, 40, 90, .2)',
                    borderColor: '#F8285A'
                }}>
                    <p className={'mb-0 f-11'}>برای دریافت اطلاع رسانی ها لطفا ایمیل خود را ثبت نمایید</p>
                    <Link className={'btn btn-danger fw-semibold me-2'} to={'/edit-profile'}>تکمیل اطلاعات</Link>
                </div>
            ) : ''}
        </>
    )
}
export default EmailIsConfirm;